export default __webpack_public_path__ + "static/media/market2.c6573330.jpg";